import { render } from "./CompanyFollowUpRecordPageList.vue?vue&type=template&id=7715a2f0&scoped=true&ts=true"
import script from "./CompanyFollowUpRecordPageList.vue?vue&type=script&lang=ts"
export * from "./CompanyFollowUpRecordPageList.vue?vue&type=script&lang=ts"

import "./CompanyFollowUpRecordPageList.vue?vue&type=style&index=0&id=7715a2f0&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7715a2f0"]])

export default __exports__